import { Component } from "@angular/core";
import { ButtonModule } from "primeng/button";

@Component({
  selector: 'pricing-widget',
  standalone: true,
  imports: [ButtonModule],
  template: `
    <section class="py-12 px-6 md:px-12 lg:px-20">
      <h2 class="text-3xl font-bold mb-8">
        Pricing Based on Workflows, Not Messages
      </h2>

      <div class="grid md:grid-cols-3 gap-6">
        <div class="plan">
          <h3>Starter</h3>
          <p>Test workflows & concepts</p>
          <ul>
            <li>✔ Workflow engine</li>
            <li>✔ WhatsApp automation</li>
            <li>✔ Knowledge base</li>
          </ul>
          <button pButton label="Start Trial"></button>
        </div>

        <div class="plan featured">
          <h3>Growth</h3>
          <p>Operational teams</p>
          <ul>
            <li>✔ Bulk workflows</li>
            <li>✔ Broadcast & aggregation</li>
            <li>✔ n8n integration</li>
          </ul>
          <button pButton label="Book Demo"></button>
        </div>

        <div class="plan">
          <h3>Enterprise</h3>
          <p>Large-scale operations</p>
          <ul>
            <li>✔ Voice automation</li>
            <li>✔ SLA & compliance</li>
            <li>✔ Custom policies</li>
          </ul>
          <button pButton label="Contact Sales"></button>
        </div>
      </div>
    </section>
  `,
  styles: [`
    .plan {
      border: 1px solid var(--surface-border);
      padding: 1.25rem;
      border-radius: var(--gh-r-sm);
    }
    .featured {
      border-width: 2px;
    }
  `]
})
export class PricingWidget {}
